import { ContentSharingEmailModel } from './content-sharing-email.model';
import { ContentSharingFacebookModel } from './content-sharing-facebook.model';
import { ContentSharingLinkedinModel } from './content-sharing-linkedin.model';
import { ContentSharingTweetModel } from './content-sharing-tweet.model';

export class ContentSharingModel {
    tweet: ContentSharingTweetModel = null;
    facebook: ContentSharingFacebookModel = null;
    linkedin: ContentSharingLinkedinModel = null;
    email: ContentSharingEmailModel = null;

    constructor(
        tweet?: ContentSharingTweetModel,
        facebook?: ContentSharingFacebookModel,
        linkedin?: ContentSharingLinkedinModel,
        email?: ContentSharingEmailModel
    ) {
        this.tweet = tweet;
        this.facebook = facebook;
        this.linkedin = linkedin;
        this.email = email;
    }
}
